import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import approval from "./approval.module";
import tenant from "./mtenant.module";
import adminuser from "./adminuser.module";
import account from "./account.module";
import businessCost from "./businessCost.module";
import business from "./business.module";
import subcontractor from "./subcontractor.module";
import forecast from "./forecast.module";
import notification from "./notification.module";
import formAnswer from "./formAnswer.module";
import voucher from "./voucher.module";
import formAnswerChild from "./formAnswerChild.module"
import fileUpload from "./upload.module"


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    approval,
    tenant,
    adminuser,
    account,
    businessCost,
    business,
    subcontractor,
    forecast,
    notification,
    formAnswer,
    voucher,
    formAnswerChild,
    fileUpload
  }
});
